<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 200 200"
    :width="size"
    :height="size"
    :style="{ color }"
  >
    <defs>
      <radialGradient
        :id="gradientId"
        cx=".66"
        fx=".66"
        cy=".3125"
        fy=".3125"
        gradientTransform="scale(1.5)"
      >
        <stop offset="0" :stop-color="color" />
        <stop offset=".3" :stop-color="color" stop-opacity=".9" />
        <stop offset=".6" :stop-color="color" stop-opacity=".6" />
        <stop offset=".8" :stop-color="color" stop-opacity=".3" />
        <stop offset="1" :stop-color="color" stop-opacity="0" />
      </radialGradient>
    </defs>

    <circle
      transform-origin="center"
      fill="none"
      :stroke="`url(#${gradientId})`"
      stroke-width="15"
      stroke-linecap="round"
      stroke-dasharray="200 1000"
      stroke-dashoffset="0"
      cx="100"
      cy="100"
      r="70"
    >
      <animateTransform
        attributeName="transform"
        type="rotate"
        calcMode="spline"
        dur="2s"
        values="360;0"
        keyTimes="0;1"
        keySplines="0 0 1 1"
        repeatCount="indefinite"
      />
    </circle>

    <circle
      transform-origin="center"
      fill="none"
      opacity=".2"
      :stroke="color"
      stroke-width="15"
      stroke-linecap="round"
      cx="100"
      cy="100"
      r="70"
    />
  </svg>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
  size: {
    type: [Number, String],
    default: 40,
  },
  color: {
    type: String,
    default: "#000000",
  },
});

// Generate a unique gradient ID (important if multiple spinners exist)
const gradientId = computed(() => {
  const array = new Uint32Array(1);
  if (typeof crypto !== 'undefined' && crypto.getRandomValues) {
    crypto.getRandomValues(array);
    return `spinner-gradient-${array[0].toString(36)}`;
  } else {
    // Fallback for environments without crypto support
    return `spinner-gradient-${Date.now().toString(36)}`;
  }
});
</script>
